export default "__VITE_ASSET__BQRtSEsM__"